<template>
    <x-modal :id="modalId" title="Tambah Journey">
        <x-form-group :horizontal="false" label="Tanggal">
            <input
                type="datetime-local"
                class="form-control"
                v-model="fields.created_at"
            />
        </x-form-group>
        <x-form-group :horizontal="false" label="Keterangan">
            <input
                type="text"
                class="form-control"
                v-model="fields.label"
                placeholder="Keterangan"
            />
        </x-form-group>
        <template #footer>
            <x-submit-button @click.prevent="handleSubmit" />
            <x-close-modal-button />
        </template>
    </x-modal>
</template>

<script>
import XCloseModalButton from "../../components/XCloseModalButton.vue";
import XFormGroup from "../../components/XFormGroup.vue";
import XModal from "../../components/XModal.vue";
import XSubmitButton from "../../components/XSubmitButton.vue";

export default {
    components: { XModal, XFormGroup, XCloseModalButton, XSubmitButton },
    data() {
        return {
            fields: {
                created_at: new Date().toISOString().split("T")[0], // Default to today
                label: "",
            },
        };
    },
    methods: {
        handleSubmit() {
            if (!this.fields.label) {
                this.$notify({
                    type: "error",
                    title: `Error`,
                    text: `Keterangan harus diisi!`,
                });
                return;
            }
            if (!this.fields.created_at) {
                this.$notify({
                    type: "error",
                    title: `Error`,
                    text: `Tanggal harus diisi!`,
                });
                return;
            }
            this.$emit("submit", {
                ...this.fields,
            });
            this.fields = {
                created_at: new Date().toISOString().split("T")[0],
                label: "",
            }; // Reset fields
            $(`#${this.modalId}`).modal("hide"); // Hide modal
            this.$notify({
                type: "success",
                title: `Berhasil`,
                text: `Journey berhasil ditambahkan!`,
            });
        },
    },
    props: {
        modalId: {
            type: String,
            default: "add-milestone-modal",
        },
    },
};
</script>
